import pinia from '@/store';
import useSettingsStore from '@/store/modules/settings';
const settingsStore = useSettingsStore(pinia);
const storage = {
    local: {
        has: (key) => {
            return Object.prototype.hasOwnProperty.call(localStorage, `${settingsStore.settings.app?.storagePrefix}${key}`);
        },
        get: (key) => {
            return localStorage.getItem(`${settingsStore.settings.app?.storagePrefix}${key}`);
        },
        set: (key, value) => {
            localStorage.setItem(`${settingsStore.settings.app?.storagePrefix}${key}`, value);
        },
        remove: (key) => {
            localStorage.removeItem(`${settingsStore.settings.app?.storagePrefix}${key}`);
        },
        clear: () => {
            localStorage.clear();
        },
    },
    session: {
        has: (key) => {
            return Object.prototype.hasOwnProperty.call(sessionStorage, `${settingsStore.settings.app?.storagePrefix}${key}`);
        },
        get: (key) => {
            return sessionStorage.getItem(`${settingsStore.settings.app?.storagePrefix}${key}`);
        },
        set: (key, value) => {
            sessionStorage.setItem(`${settingsStore.settings.app?.storagePrefix}${key}`, value);
        },
        remove: (key) => {
            sessionStorage.removeItem(`${settingsStore.settings.app?.storagePrefix}${key}`);
        },
        clear: () => {
            sessionStorage.clear();
        },
    },
};
export default storage;
